import {
	Component,
	NgZone,
  OnInit
}									from '@angular/core';
import {
	MapConfig,
	MapCoord,
	ConfigService,
	MapService
}									from '../../';

declare var document: any;

@Component({
  selector:			'electra-map',
  styleUrls:		[ './map.component.scss' ],
  templateUrl:	'./map.component.html'
})
export class MapComponent implements OnInit {
	mapReady = false
	popup = ''

	_currentLocation: MapCoord = null;
	currentLocationMarker: any;

	get currentLocation(): MapCoord {
		return this._currentLocation;
	}

	set currentLocation(newCurrentLocation: MapCoord) {
		this._currentLocation = newCurrentLocation;

		if (this.currentLocationMarker) {
			if (newCurrentLocation !== null) {
				this.currentLocationMarker.setPosition(newCurrentLocation);
				this.currentLocationMarker.setMap(this.mapService.map);
			} else {
				this.currentLocationMarker.setMap(null);
			}
		}
	}

	get currentLocationClass(): string {
		return (this.currentLocation !== null ? '' : 'hide') + (this.configService.mobile ? '' : ' desktop');
	}

  get popupClass(): string {
    return (this.popup.length === 0 ? 'hide' : '') + (this.configService.mobile ? '' : ' desktop');
  }

  constructor(public configService: ConfigService, public mapService: MapService, public zone: NgZone) {
		configService.map.subscribe((data) => { this.gotConfig(data); });

    mapService.gmapsReady.push({ callback: () => {

      /*if ((<any>window).cordova !== undefined) {
        document.addEventListener("deviceready", () => {
          this.startWatchingPosition();
        }, false);
      } else {*/
      setTimeout(t => {
        t.startWatchingPosition();
      }, 500, this);
      //}
    }, context: this });
  }
  
  startWatchingPosition() {
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(position => {
          if (!this.currentLocationMarker) {
            this.currentLocationMarker =  new this.mapService.gmaps.Marker({
              icon:			{
                url: 'assets/electraAssets/currentLocationMarker.svg',
                scaledSize: new this.mapService.gmaps.Size(32, 32)
              },
              position: { lat: 0, lng: 0 },
              zIndex: 	50
            });
          }
          this.currentLocation = new MapCoord(position.coords.latitude, position.coords.longitude);
      }, error => {
        this.currentLocation = null;

        console.log(error);
      }, {
        enableHighAccuracy: false,
        timeout:						10000,
        maximumAge:					10000
      })
    } 
  }

	currentLocationClick() {
		this.mapService.setPosition(this.currentLocation);
	}

	ngOnInit() {
		this.mapReady = true

		this.mapService.popup.subscribe((data) => { this.gotPopup(data) })
	}

	gotConfig(config: MapConfig) {
		if (this.mapReady) {
      setTimeout((t) => {
        t.mapService.getMap('gmap', {
          maxZoom: 18,
          zoomControl: config.zoom, // Only show zoom buttons in desktop UI
          disableDefaultUI: true,
          streetViewControl: true,
          mapTypeControl: true,
          styles: [{
            stylers: [{ "saturation": config.grayScale }]
          }]
        })

        if (config.fit.length > 0) {
          t.mapService.map.fitBounds({
            south: config.fit[0][0],
            west: config.fit[0][1],
            north: config.fit[1][0],
            east: config.fit[1][1]
          })
        }
      }, 500, this);
		}
	}

	gotPopup(popup: string) {
		this.zone.run(() => {
			this.popup = popup;

			document.getElementById('popup-content').innerHTML = popup;
		});
	}

	popupClose() {
		this.popup = '';
		
		setTimeout((t) => {
			t.mapService.popup.next('');
		}, 250, this);
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/map/map.component.ts